import React from 'react'

import BButton from 'components/Form/Fields/BButton'

const Checkout3 = ({t, back}) => (
  <div id='checkout3'>
    <h1>{t('Payment')}</h1>

    <BButton ghost onClick={back}>{t('back to step 2')}</BButton>
  </div>
)

export default Checkout3
